import getI18nProps from '@/utils/i18/getI18nProps';
import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'next-i18next';
import React from 'react';
import DepositBenefits from './deposit';
import BenefitsOverview from './overview';

// export const runtime = 'experimental-edge';
export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale, additionalNamespaces: ['benefits'] })),
    },
  };
}

export default BenefitsOverview;
